/**
 * Typed SSO configuration API facade over the generated contract client.
 */

import { ssoApi } from '../api/generated/sso.api.js';
import type {
  ConfigureSsoRequest,
  ConfigureSsoResponse,
  SsoLoginResponse,
  SsoTestConnectionResponse,
} from '../types/sso.js';

class SsoService {
  async configureSso(tenantId: string, config: ConfigureSsoRequest): Promise<ConfigureSsoResponse> {
    return ssoApi.configure({ tenantId }, config) as Promise<ConfigureSsoResponse>;
  }

  async getSsoLoginUrl(tenantId: string, redirectUri: string): Promise<SsoLoginResponse> {
    return ssoApi.getLoginUrl({ tenantId, redirectUri }) as Promise<SsoLoginResponse>;
  }

  async disableSso(tenantId: string): Promise<void> {
    await ssoApi.disable({ tenantId });
  }

  async testSsoConnection(tenantId: string): Promise<SsoTestConnectionResponse> {
    return ssoApi.testConnection({ tenantId }) as Promise<SsoTestConnectionResponse>;
  }
}

export const ssoService = new SsoService();
